export const logToServer = async (
  level: 'debug' | 'info' | 'warn' | 'error',
  section: string,
  message: string,
  data?: any
) => {
  if (level !== 'error' && window.location.hostname !== 'localhost') {
    return;
  }
  try {
    await fetch('/api/log', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ level, section, message, data })
    });
  } catch (error) {
    console.error('Failed to log to server:', error);
  }
};